import { createAction } from '@ngrx/store';

const actionGroupName: string = 'Router';

export const EmployeeLogout = createAction(
  `${actionGroupName} Employee logout`
);
